export const pt = {
  // Header
  nav: {
    home: 'Início',
    about: 'Sobre',
    services: 'Serviços',
    gallery: 'Galeria',
    testimonials: 'Depoimentos',
    contact: 'Contato',
    whatsapp: 'WhatsApp'
  },

  // Home Page
  home: {
    hero: {
      title: 'Transforme seu Espaço com',
      titleHighlight: 'Pisos e Azulejos de Qualidade',
      tagline: 'Instalação profissional de pisos e azulejos com acabamento perfeito',
      ctaQuote: 'Solicitar Orçamento',
      ctaGallery: 'Ver Galeria'
    },
    stats: {
      experience: 'Anos de Experiência',
      projects: 'Projetos Realizados',
      satisfaction: 'Clientes Satisfeitos'
    },
    servicesSection: {
      title: 'Nossos Serviços',
      subtitle: 'Oferecemos soluções completas em pisos e azulejos para transformar seu ambiente'
    },
    whyUs: {
      title: 'Por Que Nos Escolher?',
      subtitle: 'Compromisso com qualidade e satisfação do cliente',
      benefits: [
        'Profissionais experientes e qualificados',
        'Materiais de primeira qualidade',
        'Acabamento impecável e detalhista',
        'Orçamento transparente e sem surpresas',
        'Cumprimento de prazos rigoroso',
        'Garantia de 1 ano em todos os serviços'
      ]
    },
    testimonialsSection: {
      title: 'O Que Dizem Nossos Clientes',
      subtitle: 'Experiências reais de quem confiou em nosso trabalho'
    },
    cta: {
      title: 'Pronto para Transformar seu Ambiente?',
      subtitle: 'Entre em contato agora e solicite um orçamento gratuito sem compromisso',
      button: 'Falar no WhatsApp'
    }
  },

  // About Page
  about: {
    title: 'Sobre Nós',
    subtitle: 'Conheça nossa história e o compromisso que temos com a qualidade e satisfação dos nossos clientes',
    historyTitle: 'Nossa História',
    description: 'Somos especialistas em instalação de pisos e azulejos com mais de 10 anos de experiência no mercado. Nossa equipe altamente qualificada oferece serviços de alta qualidade, sempre priorizando o acabamento perfeito e a satisfação dos nossos clientes.',
    description2: 'Com uma equipe dedicada e apaixonada pelo que faz, buscamos constantemente a excelência em cada projeto. Utilizamos técnicas modernas e materiais de primeira linha para garantir durabilidade e beleza aos nossos trabalhos.',
    valuesTitle: 'Nossos Valores',
    values: {
      quality: { title: 'Qualidade', desc: 'Compromisso com a excelência em cada detalhe do nosso trabalho' },
      professionalism: { title: 'Profissionalismo', desc: 'Equipe qualificada e treinada para atender com excelência' },
      precision: { title: 'Precisão', desc: 'Atenção aos detalhes e acabamento impecável em cada projeto' },
      satisfaction: { title: 'Satisfação', desc: 'Cliente no centro de tudo o que fazemos' }
    },
    statsTitle: 'Nossos Números',
    whyUsTitle: 'Por Que Nos Escolher?',
    reasons: [
      { title: 'Experiência Comprovada', desc: 'Mais de uma década de atuação no mercado, com centenas de projetos bem-sucedidos.' },
      { title: 'Materiais de Qualidade', desc: 'Utilizamos apenas materiais certificados e de fornecedores confiáveis.' },
      { title: 'Equipe Qualificada', desc: 'Profissionais treinados e em constante atualização técnica.' },
      { title: 'Atendimento Personalizado', desc: 'Cada projeto é único e recebe atenção especial da nossa equipe.' },
      { title: 'Garantia e Suporte', desc: 'Oferecemos 1 ano de garantia em todos os nossos serviços.' },
      { title: 'Prazos Cumpridos', desc: 'Compromisso com o cronograma estabelecido desde o início.' }
    ]
  },

  // Services Page
  services: {
    title: 'Nossos Serviços',
    subtitle: 'Soluções completas em pisos e azulejos para todos os tipos de ambientes',
    processTitle: 'Nosso Processo',
    process: [
      { title: 'Consulta Inicial', desc: 'Entre em contato e agende uma visita técnica gratuita' },
      { title: 'Orçamento', desc: 'Elaboramos um orçamento detalhado e sem compromisso' },
      { title: 'Execução', desc: 'Nossa equipe realiza o serviço com qualidade e pontualidade' },
      { title: 'Entrega', desc: 'Finalizamos com limpeza completa e garantia do serviço' }
    ],
    differentialsTitle: 'Diferenciais',
    differentials: [
      { title: 'Materiais Premium', desc: 'Utilizamos apenas pisos e azulejos de alta qualidade e materiais certificados' },
      { title: 'Equipe Especializada', desc: 'Profissionais com anos de experiência e treinamento constante' },
      { title: 'Garantia Estendida', desc: '1 ano de garantia em todos os serviços executados' },
      { title: 'Atendimento Rápido', desc: 'Respondemos rapidamente e agendamos visitas com agilidade' },
      { title: 'Limpeza Total', desc: 'Deixamos o ambiente limpo e organizado após a conclusão' },
      { title: 'Preço Justo', desc: 'Orçamentos transparentes sem custos ocultos' }
    ],
    ctaTitle: 'Interessado em Nossos Serviços?',
    ctaSubtitle: 'Entre em contato agora e solicite um orçamento gratuito',
    ctaButton: 'Solicitar Orçamento'
  },

  // Gallery Page
  gallery: {
    title: 'Galeria de Projetos',
    subtitle: 'Confira alguns dos nossos trabalhos realizados',
    categories: {
      all: 'Todos',
      toilet: 'Banheiro',
      mosaic: 'Mosaico',
      pool: 'Piscina',
      bedroom: 'Quarto',
      shopping: 'Shopping'
    }
  },

  // Testimonials Page
  testimonials: {
    title: 'Depoimentos',
    subtitle: 'Veja o que nossos clientes têm a dizer sobre nossos serviços',
    avgRating: 'Avaliação Média',
    happyClients: 'Clientes Satisfeitos',
    recommendation: 'Recomendação',
    ctaTitle: 'Quer Ser Nosso Próximo Cliente Satisfeito?',
    ctaSubtitle: 'Entre em contato e transforme seu ambiente com qualidade e profissionalismo',
    ctaButton: 'Solicitar Orçamento Gratuito'
  },

  // Contact Page
  contact: {
    title: 'Entre em Contato',
    subtitle: 'Estamos prontos para transformar seu ambiente. Fale conosco!',
    phone: 'Telefone',
    email: 'Email',
    location: 'Localização',
    hours: 'Horário',
    whatsappButton: 'Falar no WhatsApp',
    formTitle: 'Solicitar Orçamento',
    form: {
      name: 'Nome Completo',
      email: 'Email',
      phone: 'Telefone',
      service: 'Serviço de Interesse',
      selectService: 'Selecione um serviço',
      message: 'Mensagem',
      messagePlaceholder: 'Descreva seu projeto...',
      sendWhatsApp: 'Enviar via WhatsApp',
      sendEmail: 'Enviar por Email',
      other: 'Outro'
    },
    faqTitle: 'Perguntas Frequentes',
    toastRedirect: 'Redirecionando para WhatsApp!',
    toastDesc: 'Você será direcionado para enviar a mensagem.'
  },

  // Footer
  footer: {
    description: 'Especialistas em soluções de pisos e azulejos com excelência e qualidade há mais de 10 anos.',
    quickLinks: 'Links Rápidos',
    contactTitle: 'Contato',
    socialMedia: 'Redes Sociais',
    socialDesc: 'Siga-nos nas redes sociais e fique por dentro das novidades.',
    copyright: 'Todos os direitos reservados.'
  },

  common: {
    viewAll: 'Ver Todos os Serviços',
    viewAllTestimonials: 'Ver Todos os Depoimentos',
    readMore: 'Ler Mais',
    learnMore: 'Saiba Mais'
  }
};